import React from 'react'
import { Outlet } from 'react-router-dom'
import PageTabs from '../shared/PageTabs.jsx'
import '../../styles/pages.css'

const tabs = [
  { path: '/inventory/list', label: 'Inventory' },
  { path: '/inventory/stock-check', label: 'Stock Check' },
  { path: '/inventory/drafts', label: 'Drafts Manager' },
  { path: '/inventory/activation-history', label: 'Activation History' },
  { path: '/inventory/collections', label: 'Collections' },
  { path: '/inventory/printing', label: 'Printing' }
]

function InventoryPage() {
  return (
    <div className="page">
      <div className="pageHead">
        <h1>Inventory</h1>
        <p>Manage stock, pricing, and product data</p>
      </div>

      <PageTabs tabs={tabs} match="exact" />

      <div style={{ marginTop: 28 }}>
        <Outlet />
      </div>
    </div>
  )
}

export default InventoryPage
